<template>
    <div class="introductionBox">
       <businessBanner tabIndex="6"></businessBanner>
       <div :class="isMobile?'mobileShow':'mainShow'">
            <p class="font20 fontw">数智化应用</p>
            <p class="mt36 jies">依托专业的数智化技术团队，瑞和安惠自主研发了集全方位行政管理、全过程费用管理、全流程业务管理及全面化信息管理于一体的OA系统，同时为适应集团高速发展的需求，又相继开发了以目标管理为核心的OKR系统、以客户管理为核心的CRM系统，以及PMO业务管理中枢系统，经过二十多年持续的实践检验与技术迭代，形成了完善的数智化综合管理系统。</p>
            <p class="mt20 jies">随着国家"十五五"规划明确了"深入推进数字中国建设"路径，以及国家发展改革委政策文件明确鼓励工程咨询机构开发和利用人工智能技术，促进工程咨询行业数智化转型发展。在此背景下，瑞和安惠深度融合工程咨询与数智化应用，明确了从"人力驱动"向"平台驱动、智慧赋能"的转型思路；确定了"数智化平台赋能全过程工程咨询"的战略目标；完成了"数智化工程咨询产品体系"与"工程咨询数智化业务平台"建设的战略部署；产出了多款数智化工程咨询产品，其中多款产品被国家版权局授予计算机软件著作权；并在多个项目中实现了工程咨询数智化技术突破，广受业主好评与行业赞誉。瑞和安惠已在工程咨询行业数智化转型浪潮中取得了实质性成果。</p>
       </div>
       <div :class="isMobile?'mobileShows':'mainShows mt42'">
            <div :class="isMobile?'mainM':'main clearfix'">
                <div :class="isMobile?'contM':'fl cont'">
                    <div :class="isMobile?'contTM':'contT'">数智化OA系统</div>
                    <p>集全方位行政管理、全过程费用管理、全流程业务管理、全面化信息管理于一体，融合人工智能完成OA系统数智化迭代。实现组织运营高效协同、业务流程AI赋能、数据资产持续积累、管理决策智能分析，从而大幅提升管理效能、业务效率与决策科学性。</p>
                </div>
                <img :class="isMobile?'contImgShow':'fr bImg1'" src="@/assets/businessScope/bim1.png" alt="">
            </div>
       </div>
        <div :class="isMobile?'mainM':'mainShowd clearfix'">
            <p v-if="isMobile" :class="isMobile?'contTM':'contT'">CRM客户管理系统</p>
            <img :class="isMobile?'contImgShow':'fl bImg2'" src="@/assets/businessScope/bim2.png" alt="">
            <div :class="isMobile?'contM':'fr contLeft'">
                <div v-if="!isMobile" :class="isMobile?'contTM':'contT'">CRM客户管理系统</div>
                <p>通过打造数智化共享价值平台，集成客户、营销、销售、服务、品牌、产品等功能要素，实现对市场端的精准信息推送、市场动态跟踪、市场资源协调、关键环节支持与智能数据分析，从而全面提升市场管理绩效与客户满意度，赋能市场工作开展。</p>
            </div>
        </div>
       <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main clearfix'">
                <div :class="isMobile?'contM':'fl cont'">
                    <div :class="isMobile?'contTM':'contT'" :style="`${isMobile?'':'margin-top:80px'}`">PMO业务管理系统</div>
                    <p>通过数智化系统将市场动态、业务流程、人力资源、费用成本进行横向贯通与数据关联，对项目全过程实施动态监控，根据智能分析进行业务资源配置、业务流程管控、人力资源调度与项目成本测算，从而作出科学、准确的项目评估、预警与纠偏、止损决策。</p>
                </div>
                <img :class="isMobile?'contImgShow':'fr bImg3'" src="@/assets/businessScope/bim3.png" alt="">
            </div>
       </div>
        <div :class="isMobile?'mainM':'mainShowd clearfix'">
            <p v-if="isMobile" :class="isMobile?'contTM':'contT'">BIM技术应用</p>
            <img :class="isMobile?'contImgShow':'fl bImg4'" src="@/assets/businessScope/bim4.png" alt="">
            <div :class="isMobile?'contM':'fr contRight'">
                <div v-if="!isMobile" :class="isMobile?'contTM':'contT'">BIM技术应用</div>
                <p>瑞和安惠2013年组建BIM中心。利用BIM技术可视化、协调性、模拟性、优化性和可出图性优势，结合无人机、VR、全景影像等设备，先后在枣强县人民医院、曹妃甸环保产业园、玉田县医院整体迁建、中国(河北)自贸试验区正定片区金融创新及进口商品展示交易中心、石家庄市第四十中新校区改建等项目成功运用BIM技术，并积极研究BIM技术的创新应用点。先后获得了"龙图杯"三等奖、中建协BIM大赛卓越工程项目二等奖、河北省第一～四届"燕赵杯"BIM技术应用大赛一、二等奖。</p>
            </div>
        </div>
       <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main clearfix'">
                <div :class="isMobile?'contM':'fl cont'">
                    <div :class="isMobile?'contTM':'contT'" :style="`${isMobile?'':'margin-top:30px'}`">电子招标投标交易平台</div>
                    <p>业务功能覆盖发标、投标、开标、评标、定标等招投标全部业务环节，并引入了河北CA、银联支付、电子保函、支付宝、电子发票等第三方平台接口。瑞和安惠利用"交易平台"处理招投标活动中的发标、投标、开标、评标、定标等环节，应用招标文件制作工具以填空或选择的形式完成招标文件的编制，从登记项目信息开始，包括使用辅助工具制作招标文件、发布公告、审核报名及缴费情况（如有）、澄清踏勘、抽取专家、发布中标候选人公示、发布中标公告等。实现了线上开展招标活动，并全程留痕，所有操作以数字电文的形式存储，可追溯、可审计。</p>
                </div>
                <img :class="isMobile?'contImgShow':'fr bImg5'" src="@/assets/businessScope/bim5.png" alt="">
            </div>
       </div>
        <div :class="isMobile?'mainM':'mainShowd clearfix'">
            <p v-if="isMobile" :class="isMobile?'contTM':'contT'">造价业务管理系统</p>
            <img :class="isMobile?'contImgShow':'fl bImg6'" src="@/assets/businessScope/bim6.png" alt="">
            <div :class="isMobile?'contM':'fr contRight'" :style="`${isMobile?'':'margin-top:0'}`">
                <div v-if="!isMobile" :class="isMobile?'contTM':'contT'">造价业务管理系统</div>
                <p>瑞和安惠自主研发了集业务管理与流程管控于一体的造价业务管理平台，员工通过"管理系统"实现线上工作推送、任务分工、进度编制及质量审核，实现全过程造价咨询的线上办公及档案留存。"管理系统"集成了合同登记、项目立项、资料准备、计划编制、初稿审核、终稿审核、项目归档业务的全流程管控，运用信息化技术处理使其简单、自动和智能。</p>
            </div>
        </div>
       <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main clearfix'">
                <div :class="isMobile?'contM':'fl cont'">
                    <div :class="isMobile?'contTM':'contT'" :style="`${isMobile?'':'margin-top:20px'}`">全咨业务管理系统</div>
                    <p>瑞和安惠自主研发了基于轻量化BIM的全过程咨询协同平台。通过平台让项目经理掌控单个或多个项目的目标控制情况，随时随地掌握项目人员工作情况。平台基于轻量化BIM模型，具有灵活、简便的体系架构，贯穿项目全生命周期，以业主为核心，各参建方高效协同，动态据支持决策，可扩展构件级信息，全程记录，永久追溯，可交付完整竣工模型，后续服务延伸至运维阶段。为客户提供透明、高效、节资、节时的超值服务。</p>
                </div>
                <img :class="isMobile?'contImgShow':'fr bImg7'" src="@/assets/businessScope/bim7.png" alt="">
            </div>
       </div>
        <div :class="isMobile?'mainM':'mainShowd clearfix'">
            <p v-if="isMobile" :class="isMobile?'contTM':'contT'">投资咨询业务管理系统</p>
            <img :class="isMobile?'contImgShow':'fl bImg8'" src="@/assets/businessScope/bim8.png" alt="">
            <div :class="isMobile?'contM':'fr contRight'">
                <div v-if="!isMobile" :class="isMobile?'contTM':'contT'">投资咨询业务管理系统</div>
                <p>投资咨询业务管理系统是专门为工程咨询供需双方搭建的智库平台，运用2B2C模式，通过云计算、大数据、区块链、AI技术、数字经济等先进技术手段，为需求方快速精准匹配随需而动的服务资源，解决项目机会、工程师和专家、行业智库等一系列资源共享问题。瑞和安惠利用管理系统开展前期规划咨询、项目咨询、专项咨询，线上进行需求发布、项目协作、资料查询等工作，实现投资决策综合性咨询的资源共享、人才共享、共同协作，提高了工作效率。</p>
            </div>
        </div>
        <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'showsM':'shows'">
                <p>除以上数字化平台、系统工具应用外，在数字化方面，瑞和安惠还参与了河北省多项"建筑信息模型"相关标准、信息化研究课题及中咨协会《新基建数字化项目管理指南》《投资决策综合性咨询数字化应用指南》等数字化应用相关标准，理论与实践相结合，持续助力、推进数字化在工程咨询行业的应用与发展。</p>
                <p style="margin-top:16px;">基于招标采购、投资咨询、造价咨询与管理咨询四大传统咨询业务场景，结合数智化应用，整合数智化工程咨询产品，搭建"智采融合""云咨智策""惠算成本""智控交付"四大新型数智化业务平台体系，持续为客户提供差异化增值服务与数智化应用体验。</p>
            </div>
       <!-- 典型业绩展示 -->
       <TypicalAchievement category-id="100144" :show-tabs="false"  />
       </div>
    </div>
</template>

<script>
import businessBanner from '@/components/businessBanner'
import TypicalAchievement from '@/components/TypicalAchievement.vue'
	export default {
		name:'EarlierConsultation',
        components:{businessBanner, TypicalAchievement},
        data() {
            return {

            }
        },
        mounted() {

        }
	}
</script>

<style scoped>
    .introductionBox{
        padding-bottom: 50px;
    }
    .mainShows{
        width: 100%;
        background-color: #F7F9FD;
    }
    .mobileShows{
        width: 100%;
        background-color: #F7F9FD;
        margin-top: 20px;
    }
    .mainShowd{
        width: 1200px;
        margin: 0 auto;
        padding: 56px 0;
    }
    .main{
        width: 1200px;
        margin: 0 auto;
        padding-top:47px;
        padding-bottom: 60px;
        position: relative;
    }
    .mainM{
        width: 100%;
        margin: 0 auto;
        padding: 10px;
    }
    .jies{
        line-height: 30px;
        text-indent: 2em;
    }
    .cont{
        width: 525px;
        color: #666;
    }
    .contM{
        width: 100%;
        color: #666;
        line-height: 30px;
    }
    .contM p{
        text-indent: 2em;
    }
    .contT{
        color: #247CD6;
        font-size: 28px;
        margin-top: 50px;
        margin-bottom: 20px;
    }
    .contT+p{
        line-height: 36px;
    }
    .contTM{
        color: #247CD6;
        font-size: 28px;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .contTM+p{
        line-height: 30px;
        text-indent: 2em;
    }
    .contLeft{
        width:451px;
        color: #666;
    }
    .contRight{
        width:553px;
        color: #666;
        margin-top: 20px;
    }
    .contImgShow{
        max-width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .bImg1{
        width: 514px;
        height: 229px;
        margin-right: 77px;
        margin-top: 26px;
    }
    .bImg2{
        width: 708px;
        height: 293px;
    }
    .bImg3{
        width: 747px;
        height: 278px;
        margin-right: -72px;
        margin-top: 20px;
    }
    .bImg4{
        width: 566px;
        height: 399px;
        margin-left: 22px;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .bImg5{
        width:629px;
        height: 353px;
        margin-top: 25px;
    }
    .bImg6{
        width:547px;
        height: 325px;
        margin-left: 31px;
    }
    .bImg7{
        width: 620px;
        height: 285px;
        margin-top:30px;
    }
    .bImg8{
        width: 523px;
        height: 399px;
        margin-top: 14px;
    }
    .shows{
        width: 1200px;
        margin: 0 auto;
        padding: 37px 0;
        line-height: 36px;
        text-indent: 2em;
        color: #333;
    }
    .showsM{
        width: calc(100% - 20px);
        margin: 0 auto;
        padding: 37px 0;
        line-height: 36px;
        text-indent: 2em;
        color: #333;
    }
</style>
